import { Icon }      from "@chakra-ui/react";
import { IconProps } from "@chakra-ui/react";

const ArrowBackIcon = (props: IconProps) => {
	return (
		<Icon {...props}>
			<svg viewBox="0 0 512 512">
				<path fill="currentColor" d="M166.9,277.3l119.5,119.5-30.4,29.9-170.7-170.7,170.7-170.7,30.4,29.9-119.5,119.5h259.7v42.7H166.9v-.1Z"/>
			</svg>
		</Icon>
	)
}

export default ArrowBackIcon;